<script>
    import { push } from "svelte-spa-router";
    import MediaQuery from "svelte-media-query";
    import { _ } from "svelte-i18n";

    export let menuRow;

    function handleClick(menuItem) {
        if (menuItem.routerLink) {
            push(menuItem.routerLink);
        } else if (menuItem.externalLink) {
            window.location.href = menuItem.externalLink;
        } else {
            console.error("No link provided");
        }
    }
</script>

<div class="image-scaler">
    {#each menuRow as menuItem, index}
        <div
            style="width:100%"
            class="pCursor"
            on:click={handleClick(menuItem)}
        >
            <MediaQuery query="(min-width: 799px)" let:matches>
                {#if matches}
                    <img
                        class="imageBlur"
                        src={menuItem.image}
                        alt={$_(menuItem.intlName)}
                        style="display: block; object-fit: cover; height: auto; width: 100%;aspect-ratio:{menuItem.aspectRatio}; width:{menuItem.width};"
                    />
                {:else}
                    <img
                        class="imageBlur"
                        src={menuItem.image}
                        alt={$_(menuItem.intlName)}
                        style="display: block; object-fit:cover; width: 100%; max-height: {menuItem.height}"
                    />
                {/if}
            </MediaQuery>
            <div class="headline-xs" style="margin-top: 8px;">
                {$_(menuItem.intlName)}
            </div>
        </div>
        {#if index < menuRow.length - 1}
            <div
                class="divider-h"
                style=" margin-top: 24px; margin-bottom:24px;"
            />
        {/if}
    {/each}
</div>

<style>
    .image-scaler {
        width: 45%;
    }

    @media only screen and (min-width: 799px) {
        .image-scaler {
            width: unset;
            flex: 1;
        }
    }
</style>
